export default "__VITE_ASSET__D7AqR80V__"